import { render } from "./dataTableMini.vue?vue&type=template&id=6707cc6a&scoped=true"
import script from "./dataTableMini.vue?vue&type=script&lang=js"
export * from "./dataTableMini.vue?vue&type=script&lang=js"

import "./dataTableMini.vue?vue&type=style&index=0&id=6707cc6a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1337409007/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6707cc6a"]])

export default __exports__